import BaseObject from "./BaseObject";

export default class CreateEventObject2 {
  static _objectDefinition() {
    return {
      name: "",
      type: "",
      // tour: false,
      // relay: false,
      // main: false,
      eventPartner: "",
      eventRanking: null,
      eventBudget: null,
      maxEventCapacity: null,
      locationId: "",
      endLocationId: "",
      owner: "",
      description: "",
      arrivalText: "",
      departureText: "",
      arrivalAudio: "",
      departureAudio: "",
      arrivalAudioUrl: "",
      departureAudioUrl: "",
      picture: "",
      selectedTags: [],
      imageUrl: "",
      arrivalAudioName: {},
      arrivalAudioFile: {},
      arrivalAudioUrl: {},
      // chosenChildren: []
    };
  }

  static getPropertyId(name, columns) {
    for (let p in columns) {
      if (columns.hasOwnProperty(p) && p === name) {
        return columns[p];
      }
    }
  }

  static _createRequestObject(object, accounts) {
    //if tags subArray contains more than just the number
    if (object.tags.length > 0) {
      if (object.tags[0].hasOwnProperty("Selected")) {
        let _tags = {};
        object.tags.forEach(element => {
          _tags[element.TagId] = element.TagId;
        });
        object.tags = _tags;
      }
    }

    // console.log("object for _createRequestObject in CreateEventObject2: ", object);

    const tagsString = Object.assign({}, object.tags);
    console.log("Lorenzo object", object);
    let requestObject = {
      // EventId: eventId,
      Name: object.name,
      Type: object.type,
      // Tour: object.tour,
      // Relay: object.relay,
      // Main: object.main,
      EventPartner: object.eventPartner,
      EventRanking: Number(object.eventRanking),
      EventBudget: Number(object.eventBudget),
      MaxEventCapacity: Number(object.maxEventCapacity),
      LeadTime: object.leadTime,
      CooldownTime: object.cooldownTime,
      Owner: object.owner,
      // Description: object.description,
      // ArrivalText: object.arrivalText,
      // DepartureText: object.departureText,
      // ArrivalAudio: object.arrivalAudio,
      // DepartureAudio: object.departureAudio,
      // ArrivalAudioUrl: object.arrivalAudioUrl,
      // DepartureAudioUrl: object.departureAudioUrl,
      Picture: object.picture,
      LocationId: object.locationId,
      EndLocationId: object.endLocationId,
      Tags: tagsString,
      Accounts: {}
    };

    if (accounts.length > 0) {
      accounts.forEach(e => {
        requestObject.Accounts[e.accountId] = e.accountId;
      });
    }

    if (object.eventId != null) {
      requestObject.EventId = object.eventId;
    }

    return requestObject;
  }

  static _DeleteRequestObject(object) {
    let deleteRequestObject = {
      eventId: {
        datatype: "int",
        value: object.id
      }
    };
    return deleteRequestObject;
  }

  // static _createArrayWithObjects(eventObject) {
  //   // let result = BaseObject._createArrayWithObjects(eventObject);

  //   const members = JSON.parse(JSON.stringfy(eventObject.MemberOf));
  //   let result = BaseObject._toLowerCaseObjectPropertiesAtFirstLevel(eventObject);
  //   result.memberOf = BaseObject._createArrayWithObjects(members.AccountsForEvent);

  //   return result;
  // }

  /**
   * function to parse the response for
   * editEventsDesc call
   */
  static _parseDescEvents(data) {
    let outputArray = [];

    if (!data.hasOwnProperty("EventDefs")) return outputArray;
    //
    // const src = JSON.parse(data.EventDefs.EventDefsList.value);
    outputArray = BaseObject._createArrayWithObjects(data.EventDefs);
    return outputArray;
  }


  static _createArrayWithObjects(event) {
    let members = [];
    let tags = {};
    if (event.MemberOf !== undefined && event.MemberOf.AccountsForEvent !== undefined) {
      members = BaseObject._toLowerCaseInitialProperty(BaseObject._createArrayWithObjects(event.MemberOf.AccountsForEvent));
    }

    if (event.Tags !== undefined) {
      tags = BaseObject._toLowerCaseObjectPropertiesAtFirstLevelWithOutLodash(event.Tags);
    }

    let categories = [];
    if (event.Categories !== undefined) {
      categories = [...event.Categories];
    }

    let relatedEvents = [];
    if(event.RelatedEvents !== undefined) {
      relatedEvents = [...event.RelatedEvents];
    }

    let result = BaseObject._toLowerCaseObjectProperties(event);
    result.memberOf = members;
    result.tags = tags;
    result.categories = categories;
    result.relatedEvents = relatedEvents;

    console.log("result result", result)
    return result;
  }
}
